/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 警告・やることカテゴリ
 */
export type DeadlineCategory = 'NOTICE' | 'REMINDER' | 'WARNING' | 'DELAYED';

export const DeadlineCategory = {
    Notice: 'NOTICE' as DeadlineCategory,
    Reminder: 'REMINDER' as DeadlineCategory,
    Warning: 'WARNING' as DeadlineCategory,
    Delayed: 'DELAYED' as DeadlineCategory
};

